var _path, _path2, _path3, _path4, _path5, _path6, _path7, _circle, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoToQuestionnaireIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 6.5V5.25C4.5 4.69772 4.94772 4.25 5.5 4.25H6.3M4.5 9V13.25V21.25C4.5 21.8023 4.94772 22.25 5.5 22.25H18.5C19.0523 22.25 19.5 21.8023 19.5 21.25V17.75M19.5 13.25V5.25C19.5 4.69772 19.0523 4.25 18.5 4.25H17.625M9 4.25H12H14.8",
    stroke: "currentColor",
    strokeWidth: 0.6,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.2 17.45H9.3C9.41046 17.45 9.5 17.5395 9.5 17.65V19.85C9.5 19.9604 9.41046 20.05 9.3 20.05H7.2C7.08954 20.05 7 19.9604 7 19.85V17.65C7 17.5395 7.08954 17.45 7.2 17.45Z",
    stroke: "currentColor",
    strokeWidth: 0.6,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9 12.75H7.2C7.08954 12.75 7 12.8395 7 12.95V15.15C7 15.2605 7.08954 15.35 7.2 15.35H9.3C9.41046 15.35 9.5 15.2605 9.5 15.15V14.83",
    stroke: "currentColor",
    strokeWidth: 0.6,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.60001 13.8L8.90293 14.1474C8.94162 14.1917 9.01006 14.1932 9.05067 14.1506L10.1 13.05",
    stroke: "currentColor",
    strokeWidth: 0.6,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9 8.25H7.2C7.08954 8.25 7 8.33954 7 8.45V10.65C7 10.7605 7.08954 10.85 7.2 10.85H9.3C9.41046 10.85 9.5 10.7605 9.5 10.65V10.33",
    stroke: "currentColor",
    strokeWidth: 0.6,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.60001 9.30005L8.90293 9.64736C8.94162 9.69172 9.01006 9.69324 9.05067 9.65064L10.1 8.55005",
    stroke: "currentColor",
    strokeWidth: 0.6,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 7V10.8",
    stroke: "currentColor",
    strokeWidth: 0.6,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 5.50001,
    cy: 6.05,
    r: 0.3,
    fill: "currentColor"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M11 8.75H15",
    stroke: "currentColor",
    strokeWidth: 0.6,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M11 9.75H17",
    stroke: "currentColor",
    strokeWidth: 0.6,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M11 13.55H15",
    stroke: "currentColor",
    strokeWidth: 0.6,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M11 14.55H17",
    stroke: "currentColor",
    strokeWidth: 0.6,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M11 18.25H14",
    stroke: "currentColor",
    strokeWidth: 0.6,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M11 19.25H14",
    stroke: "currentColor",
    strokeWidth: 0.6,
    strokeLinecap: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M8.9 3.35V5.45H6.3V3.35C6.3 2.63203 6.88203 2.05 7.6 2.05C8.31797 2.05 8.9 2.63203 8.9 3.35Z",
    stroke: "currentColor",
    strokeWidth: 0.6
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4 3.35V5.45H14.8V3.35C14.8 2.63203 15.382 2.05 16.1 2.05C16.818 2.05 17.4 2.63203 17.4 3.35Z",
    stroke: "currentColor",
    strokeWidth: 0.6
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 18.5L19.7113 13.2887M14.5 18.5L15.5 19.5M14.5 18.5L14.1007 19.6979M16.5 20.5L21.69 15.31M16.5 20.5L15.5 19.5M16.5 20.5L15.2749 20.9084M19.7113 13.2887L20.5 12.5C21.0523 11.9477 21.9477 11.9477 22.5 12.5V12.5C23.0523 13.0523 23.0523 13.9477 22.5 14.5L21.69 15.31M19.7113 13.2887L20.7007 14.2993M21.69 15.31L20.7007 14.2993M20.7007 14.2993L15.5 19.5M14.1007 19.6979L13.5632 21.3103C13.5372 21.3884 13.6116 21.4628 13.6897 21.4368L15.2749 20.9084M14.1007 19.6979L15.2749 20.9084",
    stroke: "currentColor",
    strokeWidth: 0.6,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoToQuestionnaireIcon);
export default __webpack_public_path__ + "static/media/go-to-questionnaire_icon.2192340ef8a839c23053bd6018803970.svg";
export { ForwardRef as ReactComponent };